/*import React from 'react';
import { styled } from '@mui/material/styles';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} rounded {...props} />
))(({ theme }) => ({
    border: `1px solid gray`,
    '&.MuiAccordion-root': {
        border: `0px solid #fafafa`,
        borderRadius: '10px',
    },
    '&.MuiAccordion-rounded':{
        border: `0px solid #fafafa`,
        borderRadius: '20px',
   },
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },

}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<KeyboardArrowDownSharpIcon sx={{ fontSize: '2.9rem'}} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === '#FAFAFA',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(0),
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function CustomizedAccordions(props) {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);

    };

    return (
        <div id="r_castContent" className="r_castContent2">
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary className="asdasd" aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>
                        <span className="r_castAndCrew2">{playdetailsv2_resources.CastHeaderResource1Text}</span>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <span className="r_castText2" itemProp="description" dangerouslySetInnerHTML={{ __html: props.data }} />
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}


*/


/**
 * @deprecated This component is unused. The updated Accordion implementation
 * lives in `ticket-info.tsx` and should be extracted into a shared component when needed.
 */

import React from 'react';
import { styled } from '@mui/material/styles';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';


const Accordion = styled((props) => (

    <MuiAccordion disableGutters elevation={0}  {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    }, 
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<KeyboardArrowDownSharpIcon sx={{ fontSize: '2.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === '#FAFAFA',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function CustomizedAccordions(props) {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);

        if (newExpanded) {
            document.getElementById("r_castContent").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    };

    return (
        <div id="r_castContent" className="r_castContent2">
            <Accordion 
            expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary className="asdasd" aria-controls="panel1d-content" id="panel1d-header">
                    <Typography>
                        <span className="r_castAndCrew2">{playdetailsv2_resources.CastHeaderResource1Text}</span>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <span className="r_castText2" itemProp="description" dangerouslySetInnerHTML={{ __html: props.data }} />
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
